
<div :class="[jel_getClassObject(content), content.theme]">
  <b-img-lazy
    v-if="content.image"
    :src="jel_getFichierSrc(content.image)"
    :alt="content.texte"
    class="taille-image mr-1"
  />

  <div
    v-if="content.texteSecondaire && content.type != 'lienMAJ'"
    class="d-inline-flex"
    v-html="modifierMessage(content.texteSecondaire)"
  />

  <!-- Les TYPES sont triés du plus courant au moins courant -->
  <!-- ***** TYPE: Liens Interne ou Externe ***** -->
  <template
    v-if="
      content.lien &&
      content.lien.field &&
      (content.lien.field.startsWith('lienInterne') || content.lien.field == 'lienExterne')
    "
  >
    <!-- Styles boutons -->
    <b-button
      v-if="isButton"
      v-bind="lienInterne()"
      :variant="boutonVariant"
      :rel="content.lien.lienInterneAsset ? 'noopener noreferrer' : ''"
      :target="targetLien"
      data-lien="liens"
      class="btn w-xs-auto w-md-auto hauteur px-4"
      :class="content.type"
      :disabled="disabled"
    >
      <span class="lien-interne-externe" v-html="texteBouton" />
      <svg-icon v-if="content.lien.nomIcone" :icon-name="content.lien.nomIcone" class="ml-4px" />
    </b-button>
    <!-- Autres styles -->
    <div v-else :class="classeCSSLien">
      <span @click.capture="gaPreventClick">
        <b-link
          v-bind="lienInterne()"
          class="text-decoration-none"
          :class="[{ 'ml-4px': content.texteSecondaire }]"
          :rel="content.lien.lienInterneAsset ? 'noopener noreferrer' : ''"
          :target="targetLien"
          :disabled="disabled"
        >
          <div :class="classeCSSLien">
            <div :class="content.type" v-html="content.texte" />
            <svg-icon
              v-if="content.lien.nomIcone"
              :icon-name="content.lien.nomIcone"
              class="taille-icone"
              :class="[
                content.lien.cssIcone,
                content.lien.positionImage === 'gauche' ? 'mr-1' : 'ml-1',
              ]"
            />
            <!-- TODO: Traiter l'affichage complet de lienMAJ -->
            <span
              v-if="content.type == 'lienMAJ' && content.texteSecondaire"
              class="d-inline-block lien-interne-externe"
              v-html="modifierMessage(content.texteSecondaire)"
            />
          </div>
        </b-link>
      </span>
    </div>
  </template>
  <!-- ***** TYPE: Hyperlien Précédent ***** -->
  <!-- Obsolète: utiliser le composant lienRetour à la place, soit pour le comportement ou le style d'affichage -->
  <template v-else-if="content.lien && content.lien.field == 'precedent'">
    <!-- Styles boutons -->
    <b-button
      v-if="isButton"
      :variant="boutonVariant"
      data-precedent="precedent"
      class="btn w-xs-auto w-md-auto hauteur px-4"
      :class="content.type"
      @click="jel_traiterRetour()"
      v-html="content.texte"
    />

    <!-- Autres styles -->
    <b-link v-else :class="content.type" @click="jel_traiterRetour()">
      <svg-icon class="mr-1" scale="0.7" icon-name="fleche-lien-gauche"></svg-icon>
      <div v-html="content.texte" />
    </b-link>
  </template>

  <!-- ***** TYPE: Hyperlien Aide ***** -->
  <template v-else-if="(content.lien && content.lien.field == 'aide') || content.type == 'aide'">
    <!-- Styles boutons -->
    <b-button
      v-if="isButton"
      :variant="boutonVariant"
      data-aide="aide"
      class="btn w-xs-auto w-md-auto hauteur px-4"
      :class="content.type"
      @click="toggleAide"
      v-html="content.texte"
    />

    <!-- Autres styles -->
    <b-link v-else :class="content.type" class="d-inline-flex" @click="toggleAide">
      <div v-html="content.texte" />
      <!-- TODO: Traiter l'affichage complet de lienMAJ -->
      <div v-if="content.type == 'lienMAJ'" v-html="content.texteSecondaire"></div>
      <!-- TODO: Erreur d'accessibilité. Un inline element ne peut contenir un block element -->
    </b-link>
  </template>

  <!-- ***** TYPE: Hyperlien Zone Escamotable ***** -->
  <template v-else-if="content.lien?.field?.includes('escamotable')">
    <!-- Styles boutons -->
    <b-button
      v-if="isButton"
      :variant="boutonVariant"
      data-aide="aide"
      class="btn w-xs-auto w-md-auto hauteur px-4"
      :class="content.type"
      @click="lienEscamotable"
      v-html="content.texte"
    />

    <!-- Autres styles -->
    <b-link v-else :class="content.type" class="d-inline-flex" @click="lienEscamotable">
      <div v-html="content.texte" />
      <!-- TODO: Traiter l'affichage complet de lienMAJ -->
      <div v-if="content.type == 'lienMAJ'" v-html="content.texteSecondaire"></div>
      <!-- TODO: Erreur d'accessibilité. Un inline element ne peut contenir un block element -->
    </b-link>
  </template>

  <!-- ***** TYPE: Lien Product Source ***** -->
  <template v-if="content.lien && content.lien.field == 'lienRetourProductSource'">
    <span v-if="['lienPrimaire', 'lienSecondaire', 'lienTertiaire'].includes(content.type)">
      <b-link
        v-if="urlProductSource || mixinEnvironnement_inEditor"
        v-bind="lienProductSource()"
        :class="content.type"
        v-html="content.texte"
      />
    </span>
    <span v-if="['boutonPrimaire', 'boutonSecondaire', 'boutonTertiaire'].includes(content.type)">
      <b-button
        v-if="urlProductSource || mixinEnvironnement_inEditor"
        :variant="boutonVariant"
        v-bind="lienProductSource()"
        :data-product-source="content.texte"
        :class="content.type"
        class="btn w-xs-auto w-md-auto hauteur px-4 btn-product-source"
        v-html="content.texte"
      >
      </b-button>
    </span>
  </template>

  <!-- ***** TYPE: Lien modale ***** -->
  <template v-else-if="content.lien && content.lien.field == 'modale'">
    <span>
      <!-- Styles boutons -->
      <b-button
        v-if="isButton"
        v-b-modal="modaleUUID"
        :variant="boutonVariant"
        :data-modale="content.texte"
        class="w-100 w-md-auto hauteur"
        :class="{
          'p-0 d-flex flex-row justify-content-between align-items-center':
            content.type == 'boutonTertiaire',
        }"
        ><div v-html="content.texte" />
        <svg-icon
          v-if="content.type == 'boutonTertiaire'"
          class="icone-fleche rotation270 ml-2"
          icon-name="fleche-bas"
        />
      </b-button>

      <!-- Autres styles -->
      <b-link v-else v-b-modal="modaleUUID" :class="content.type">
        <span v-html="content.texte" />
      </b-link>
    </span>

    <!-- Fenêtre modale -->
    <b-modal
      :id="modaleUUID"
      :hide-footer="true"
      dialog-class="modal-dialog-aide pt-0 px-2 px-md-0 h-100"
      content-class="modal-content-aide compteClair pl-2 pl-sm-2 pl-lg-5 pb-2"
      body-class="pr-2 pr-lg-5 pr-md-2 pb-sm-7 ml-0"
      header-class="compteClair pl-2 pr-0 pb-1 w-100"
    >
      <template #modal-header="{ hide }">
        <div class="d-flex mt-1">
          <div class="col-10 px-0">
            <h2 class="text-left w-100">{{ content.lien.titreModale }}</h2>
          </div>
          <div class="col-2 px-0">
            <button class="btnVide" @click="hide()">
              <svg-icon
                icon-name="icone-fermer-mince"
                color="$couleur-primaire"
                className="iconeFermer"
              />
            </button>
          </div>
        </div>
      </template>

      <div v-html="content.lien.texteModale"></div>
    </b-modal>
  </template>
</div>
